const getAnimObj = () => ({
  position: '',
  extra_spot: false,
  // history_spot: 0,
  // selected_action: null,
  action: null,
  halo: false,
  // show_action: false,
  is_bot: null,
  timebank: null,
})

const playerAnimTimeoutId = {}

const getInitialState = ({ namespace }) => ({
  anim_namespace: namespace,
  player_animation: getAnimObj(),
  players_props: {},
})

const getters = {
  players_props: state => state.players_props,
  player_animation: state => state.player_animation,
}

const actions = {
  anim_player_action(
    { state, getters, rootGetters, commit, dispatch },
    { history_spot, hasSounds },
  ) {
    if (!history_spot) return

    const action = history_spot.available_actions.find(a => a.is_selected)
    if (!action) return

    // const animDelay = 1200
    const gameSpeed = rootGetters[`tra/aplha/fh_trainer_game_speed`]
    const animDelay = gameSpeed === 'normal' ? 2000 : gameSpeed === 'fast' ? 1400 : 800

    let { players_props } = getters
    const props = {
      ...getters.players_props,
      [history_spot.position]: {
        action: action.display_name,
      },
    }
    commit('players_props', props)
    if (hasSounds) {
      dispatch('sounds_play_action', { action }, { root: true })
    }

    playerAnimTimeoutId[state.anim_namespace] = setTimeout(() => {
      players_props = {
        ...getters.players_props,
        [history_spot.position]: {},
      }
      commit('players_props', players_props)
    }, animDelay)
  },

  anim_reset({ state, commit }) {
    clearTimeout(playerAnimTimeoutId[state.anim_namespace])
    commit('anim_reset', getInitialState({ namespace: state.anim_namespace }))
  },
  anim_player_reset({ state, getters, commit, dispatch }) {
    commit('anim_set', { key: 'player_animation', value: getAnimObj() })
  },
  anim_players_props_reset({ state, getters, commit, dispatch }) {
    commit('anim_set', { key: 'players_props', value: {} })
  },
}
const mutations = {
  anim_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  anim_set(state, { key, value }) {
    state[key] = value
  },
  players_props(state, players_props) {
    state.players_props = players_props
  },
  player_animation(state, val) {
    state.player_animation = { ...getAnimObj(), ...val }
  },
  anim_player_reset(state, val) {
    state.player_animation = getAnimObj()
  },
}

// export default {
//   state,
//   getters,
//   actions,
//   mutations,
// }

function getAnimModule(namespace) {
  return {
    state: getInitialState({ namespace }),
    getters,
    actions,
    mutations,
  }
}
export { getAnimModule }
